import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import * as HSET from "./settings";
import { GenericHttpService } from "../../../services/generic-http.service";
import { Observable } from "rxjs";
import { GenericUtils } from './../../../utilities/generic-utils';

const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
@Injectable()
export class DataService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService, private genericUtils: GenericUtils) { }

  getData(url, params, widgetData): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.apiUrl}${url}`, // "./assets/data/p-d-reason.json",
      query: params
    };
    try {
      const functionToCall = this.returnFunctionToCall(widgetData);
      return this.generic.httpRequest(option).pipe(
        catchError(this.generic.handleError),
        map(functionToCall)
      );
    }
    catch (error) {
      if (error.message === 'argument is not a function. Are you looking for `mapTo()`?')
        console.log(`There is no data handler for this widget id: ${widgetData.id}`);
    }
  }

  returnFunctionToCall(widgetData) {
    if (Number(widgetData.id) === 12) {
      return this.processInwardEndToEndSlaTrend;
    }
    if (Number(widgetData.id) === 16) {
      return this.processReturnEndToEndSlaTrend;
    }
    if (Number(widgetData.id) === 24) {
      return this.processTpSLATrends;
    }
    if (Number(widgetData.id) === 8) {
      return this.processTransferEndToEndSlaTrend;
    }
    if (Number(widgetData.id) === 20) {
      return this.processWarehouseSLATrendData;
    }
    if (Number(widgetData.id) === 2) {
      return this.processOTIFTrends;
    }
  }

  processInwardEndToEndSlaTrend(data: any) {
    if (!data.data.length) return null;
    const percentage = [],
      volume = [];
    const labels = data.data.map(value => {
      if (value.date !== "None") {
        const aDate = new Date(value.date);
        percentage.push(Number(value.percentage.toFixed(2)));
        volume.push(value.volume);
        return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
      }
    });

    return { labels, percentage, volume };
  }
  processOTIFTrends(data: any) {
    if (!data.data.length) return null;
    const dataSets = data.data;
    const percentage = [],
      volume = [];

    const labels = dataSets.map(value => {
      if (value.date !== "None") {
        const aDate = new Date(value.date);
        percentage.push(Number(value.percentage.toFixed(2)));
        volume.push(value.volume);
        return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
      }
    });
    return { labels, percentage, volume };
  }
  processReturnEndToEndSlaTrend(data: any) {
    if (data.data.length === 0) return null;
    const percentage = [],
      volume = [];
    const labels = data.data.map(value => {
      if (value.date !== "None") {
        const aDate = new Date(value.date);
        percentage.push(Number(value.percentage.toFixed(2)));
        volume.push(value.volume);
        return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
      }
    });

    return { labels, percentage, volume };
  }
  processTpSLATrends(data: any) {

    if (!data.data[0].TransportationSlaTrend.length) return null; // || (data.data.length && !Object.keys(data.data[0]).length)
    const percentage = [],
      volume = [];

    const labels = data.data[0].TransportationSlaTrend.map(value => {
      const aDate = new Date(value.order_date);
      const total =
        value.breached_quantity +
        value.non_breached_quantity;
      const toFixed = (value.non_breached_quantity / total) * 100;
      percentage.push(Number(toFixed.toFixed(2)));
      volume.push(total + value.in_process_quantity);
      return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
    });

    return { labels, percentage, volume };
  }
  processTransferEndToEndSlaTrend(data: any) {
    if (data.data.length === 0) return null;
    const percentage = [], volume = [];
    const labels = data.data.map(value => {
      if (value.date !== "None") {
        const aDate = new Date(value.date);
        percentage.push(Number(value.percentage.toFixed(2)));
        volume.push(value.volume);
        return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
      }
    });

    return { labels, percentage, volume };
  }
  processWarehouseSLATrendData(data: any) {
    if (data.data[0].WarehouseSlaTrend.length === 0) return null;
    const percentage = [], volume = [];
    const labels = data.data[0].WarehouseSlaTrend.map(value => {
      const total =
        value.non_breached_quantity +
        value.breached_quantity;
      const aDate = new Date(value.creation_date);
      percentage.push(
        Number(((value.non_breached_quantity * 100) / total).toFixed(2))
      );
      volume.push(total + value.in_process_quantity);
      return `${aDate.getDate()} ${month[aDate.getMonth()]}`;
    });

    return { labels, percentage, volume };
  }
  createChart(chartData, options) {

    const chart = this.genericUtils.deepCopyFunction(HSET.chartData);
    // chart.xAxis[0].categories = chartData.labels;
    // chart.series[0].data = chartData.percentage;
    // chart.series[0].name = "SLA";
    // chart.series[1].data = chartData.volume;
    // chart.series[1].name = "Quantity";
    // chart.yAxis[0].title.text = Options.yaxisleft;
    // chart.yAxis[1].title.text = Options.yaxisright;


    //Feeding the Data
    chart.xAxis[0].categories = chartData.labels;
    chart.series[0].data = chartData.percentage;
    chart.series[1].data = chartData.volume;
    //Feeding the Data ends
    if (options[0].xAxis) {
      // do nothing for now. This is just a provision for the future
    }

    if (options[0].yAxis) {
      for (let i = 0; i < options[0].yAxis.length; i++) {

        if (options[0].yAxis[i].min) {
          chart.yAxis[i].min = options[0].yAxis[i].min;
        }
        if (options[0].yAxis[i].max) {
          chart.yAxis[i].max = options[0].yAxis[i].max;
        }

        if (options[0].yAxis[i].title) {
          const TITLE = options[0].yAxis[i].title;
          if (TITLE.text) {
            chart.yAxis[i].title.text = TITLE.text;
          }
          if (TITLE.style) {
            // do nothing for now. This is just a provision for the future
          }
        }

        if (options[0].yAxis.label) {
          const LABEL = options[0].yAxis[i].title;
          if (LABEL.text) {
            chart.yAxis[i].labels.text = LABEL.text;
          }
          if (LABEL.style) {
            chart.yAxis[i].labels.style.fontSize = LABEL.style.fontSize;
            chart.yAxis[i].labels.style.fontWeight = LABEL.style.fontWeight;
            chart.yAxis[i].labels.style.color = LABEL.style.color;
          }
        }
      }
    }

    if (options[0].legend) {
      if (options[0].legend.style) {
        const STYLE = options[0].legend.style;
        chart.legend.itemStyle.fontSize = STYLE.fontSize;
        chart.legend.itemStyle.fontWeight = STYLE.fontWeight;
        chart.legend.itemStyle.color = STYLE.color;
      }

      if (options[0].legend.colorSet) {
        const COLORSET = options[0].legend.colorSet;
        for (let i = 0; i < COLORSET.length; i++) {
          chart.series[i].color = COLORSET[i];
        }
      }
    }

    if (options[0].series) {

      if (options[0].series.name) {
        const NAMES = options[0].series.name;
        const TOOLTIP = options[0].series.tooltipSuffix ? options[0].series.tooltipSuffix : [];
        for (let i = 0; i < NAMES.length; i++) {
          chart.series[i].name = NAMES[i];
          if (TOOLTIP[i]) {
            chart.series[i].tooltip.valueSuffix = TOOLTIP[i];
          }
        }
      }
      
    }

    if (options[0].noTarget) {
      chart.series.pop();
      chart.plotOptions.line.dataLabels.enabled = false;
    }


    return chart;


  }

}